import createCachedSelector from "re-reselect"
import { createStructuredSelector } from "reselect"
import { formValueSelector, getFormValues } from "redux-form/immutable"

// components
import { ContactSelect, PublicOrganizationSelect } from "app/static/frontend/selects/containers/PieSelect"

// selectors
import { selectCustomFieldNameDict } from "shared/customFields/selectors"

// constants
import { BULK_ACTIONS_FORM_KEY } from "shared/imports/sharedConstants"

export const selectMergeSelectComponent = createCachedSelector([(state, props) => props.quorumDataType], (qdt) => {
    if (qdt === DjangIO.app.models.QuorumDataType.public_organization.value) {
        return () => PublicOrganizationSelect
    } else if (qdt === DjangIO.app.models.QuorumDataType.supporter.value) {
        return () => ContactSelect
    }

    return undefined
})((state, props) => props.bulkActionType)

export const selectMergeSelectComponentPermanentFilters = createCachedSelector(
    [(state, props) => props.quorumDataType],
    (qdt) => {
        if (qdt === DjangIO.app.models.QuorumDataType.public_organization.value) {
            return {
                organization_type: DjangIO.app.person.types.PublicOrganizationType.custom.value,
            }
        } else if (qdt === DjangIO.app.models.QuorumDataType.supporter.value) {
            return {}
        }

        return {}
    },
)((state, props) => props.bulkActionType)

export const selectBulkActionsReduxForm = (key) =>
    createCachedSelector(
        (state) => formValueSelector(BULK_ACTIONS_FORM_KEY)(state, key),
        (formValue) => formValue,
    )(() => BULK_ACTIONS_FORM_KEY)

export const selectBulkActionsFormValues = (state) => getFormValues(BULK_ACTIONS_FORM_KEY)(state)

export const bulkActionsAssignConnection = createStructuredSelector({
    assignmentInputType: selectBulkActionsReduxForm("assignment_input_type"),
    assignmentSelectType: selectBulkActionsReduxForm("assignment_select_type"),
})

export const selectbulkActionsCustomFieldTagType = createCachedSelector(
    [
        (state, props) => selectCustomFieldNameDict(props.quorumDataType)(state, props),
        selectBulkActionsReduxForm("custom_field_slug"),
    ],
    (customFieldNameDict, customFieldSlug) => {
        if (customFieldSlug) {
            const currentField = customFieldNameDict[customFieldSlug]

            if (currentField) {
                const tagTypeEnum = DjangIO.app.person.types.TagType.by_value(currentField.tag_type)

                if (tagTypeEnum) {
                    return tagTypeEnum.value
                }
            }
        }

        return undefined
    },
)((state, props) => props.uniqueFlvId)

export const bulkActionsCustomFieldConnection = (state, props) =>
    createStructuredSelector({
        customFieldNameDict: selectCustomFieldNameDict(props.quorumDataType),
        customFieldSlug: selectBulkActionsReduxForm("custom_field_slug"),
        customFieldTagType: selectbulkActionsCustomFieldTagType,
        customFieldType: selectBulkActionsReduxForm("custom_field_type"),
    })

export const bulkActionsIssueConnection = createStructuredSelector({
    issueType: selectBulkActionsReduxForm("issue_type"),
})

export const bulkActionsMergeConnection = (state, props) =>
    createStructuredSelector({
        selectComponent: selectMergeSelectComponent(state, props),
        selectComponentPermanentFilters: selectMergeSelectComponentPermanentFilters,
    })

export const bulkActionsOrganizationConnection = createStructuredSelector({
    organizationSelectType: selectBulkActionsReduxForm("organization_select_type"),
})

export const bulkActionsTeamConnection = createStructuredSelector({
    teamType: selectBulkActionsReduxForm("team_type"),
})
